import Vue from "vue";
import App from "./App.vue";

import { I18n } from "aws-amplify";
I18n.setLanguage("de");
I18n.putVocabularies({
  de: {
    "Sign Out": "Abmelden",
    "Sign In": "Anmelden",
    "Sign Up": "Konto Erstellen",
    "No account? ": "Kein Konto? ",
    Username: "Email",
    Password: "Passwort",
    "Forget your password? ": "Passwort vergessen? ",
    "Reset password": "Passwort zurücksetzen",
    "Create account": "Konto erstellen",
    "Sign In Account": "Beim Konto Anmelden",
    "Reset your password": "Passwort zurücksetzen",
    "Enter your password": "Passwort",
    "Enter your username": "Email",
    "Back to Sign In": "Zurück zur Anmeldung",
    "Send Code": "Code senden",
    "Sign Up Account": "Konto erstellen",
    "Phone Number": "Telefonnummer",
    "Have an account? ": "Hast Du schon ein Konto?",
    "New Password": "Neues Passwort",
    "Resend Code": "Code erneut senden",
    Submit: "Abschicken",
    "Your verification code": "Dein Verifizierungscode",
    "Your verification code is": "Dein Verifizierungscode ist",
    "Enter new password": "Neues Passwort eingeben",
    "Confirmation Code": "Bestätigungscode",
  },
});

import Amplify, * as AmplifyModules from "aws-amplify";
//import { Storage } from 'aws-amplify';

AmplifyModules.Analytics.autoTrack("session", {
  enable: true,
  attributes: {
    attr: "attr",
  },
});

var re = new RegExp("[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}", "g");
var prev_path = "";
//var last_tstamp = new Date()

AmplifyModules.Analytics.updateEndpoint({
  metrics: { a: "1" },
});

AmplifyModules.Analytics.autoTrack("pageView", {
  enable: true,
  eventName: "pageView",
  attributes: () => {
    var path = window.location.hash.replace(re, "*", "*", "*");
    var attrs = {
      prev_path: prev_path,
      path: path,
    };
    prev_path = path;
    return attrs;
  },
  //metrics: () => {
  //    var tstamp = new Date()
  //    var prev_path_time = Math.round((tstamp-last_tstamp)/1000)
  //    last_tstamp = tstamp
  //    return {
  //        prev_path_time: prev_path_time,
  //    }
  //},
  //metrics:{
  //    a:'1'
  //},
  type: "SPA",
  provider: "AWSPinpoint",
  getUrl: () => {
    return window.location.origin + window.location.pathname.replace(re, "*", "*", "*");
  },
});

import { AmplifyPlugin } from "aws-amplify-vue";
import aws_exports from "./aws-exports";

Amplify.configure(aws_exports);

Vue.use(AmplifyPlugin, AmplifyModules);

import VueRouter from "vue-router";
Vue.use(VueRouter);

import EventHub from "vue-event-hub";
Vue.use(EventHub);

import ChangeManager from "./util/ChangeManager";
Vue.use(ChangeManager);

import store from "./store";

const moment = require("moment");
require("moment/locale/de");

Vue.use(require("vue-moment"), {
  moment,
});

Vue.config.productionTip = false;

import PageNotFound from "./components/PageNotFound";
import HomeView from "./components/HomeView";
import LegalDocView from "./components/LegalDocView";

const SodaFeaturesView = () => import("./components/SodaFeaturesView");
const PlansMenuView = () => import("./components/PlansMenuView");
const AuthView = () => import("./components/userauth/AuthView");

const MainContentView = () => import(/* webpackChunkName: "group-app" */ "./components/MainContentView");
const ProcessesView = () => import(/* webpackChunkName: "group-app" */ "./components/ProcessesView");
const ProcessView = () => import(/* webpackChunkName: "group-app" */ "./components/ProcessView");
const MeasuresView = () => import(/* webpackChunkName: "group-app" */ "./components/MeasuresView");
const MeasureView = () => import(/* webpackChunkName: "group-app" */ "./components/MeasureView");
const CompanyView = () => import(/* webpackChunkName: "group-app" */ "./components/CompanyView");
const AccountView = () => import(/* webpackChunkName: "group-app" */ "./components/AccountView");
const ImportView = () => import(/* webpackChunkName: "group-app" */ "./components/ImportView");
const DocumentsView = () => import(/* webpackChunkName: "group-app" */ "./components/DocumentsView");
const PurchaseView = () => import(/* webpackChunkName: "group-app" */ "./components/PurchaseView");

const router = new VueRouter({
  //mode:'history',
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      meta: {
        //requiresAuth: false,
        title: "SODA - So einfach ist Datenschutz",
        metaTags: [
          {
            name: "description",
            content: "Verzeichnis aller Verarbeitungstätigkeiten (Verfahren) einfach und rechtssicher mit SODA™ erstellen. Vorlagen für Ärzte, Vereine und Steuerberater.",
          },
          {
            property: "og:title",
            content: "SODA - So einfach ist Datenschutz",
          },
          {
            property: "og:description",
            content: "Verzeichnis aller Verarbeitungstätigkeiten (Verfahren) einfach und rechtssicher mit SODA™ erstellen. Vorlagen für Ärzte, Vereine und Steuerberater.",
          },
        ],
      },
      component: HomeView,
      children: [
        {
          path: "plans",
          component: PlansMenuView,
          meta: {
            title: "SODA Preise",
            metaTags: [
              {
                name: "description",
                content: "SODA Free, SODA Pro und SODA Unlimited - Finden sie den Tarif, der zu Ihnen passt.",
              },
            ],
          },
        },
        {
          path: "features",
          component: SodaFeaturesView,
          meta: {
            title: "SODA Features",
            metaTags: [
              {
                name: "description",
                content: "SODA übernimmt die Dokumentation für Datenschutzbeauftragte und unterstützt beim Audit vor Ort und Remote. Verzeichnisexport und vieles mehr!",
              },
            ],
          },
        },
      ],
    },
    {
      path: "/imprint",
      //meta:{requiresAuth: false},
      component: LegalDocView,
    },
    {
      path: "/terms",
      //meta:{requiresAuth: false},
      component: LegalDocView,
    },
    {
      path: "/privacy",
      //meta:{requiresAuth: false},
      component: LegalDocView,
    },
    {
      path: "/auth",
      meta: { title: "SODA Authentifizierung" },
      component: AuthView,
    },
    {
      path: "/purchase",
      meta: { requiresAuth: true, title: "SODA Abonnements" },
      component: PurchaseView,
    },
    {
      path: "/app",
      component: MainContentView,
      meta: { requiresAuth: true, title: "SODA App" },
      children: [
        {
          path: "company/:id/processes",
          component: ProcessesView,
        },
        {
          path: "company/:cid/process/:pid",
          component: ProcessView,
        },
        {
          path: "company/:id/measures",
          component: MeasuresView,
        },
        {
          path: "company/:cid/measure/:msid",
          component: MeasureView,
        },
        {
          path: "company/:cid/upload",
          component: ImportView,
        },
        {
          path: "company/:cid/template",
          component: ImportView,
        },
        {
          path: "company/:cid/documents",
          component: DocumentsView,
        },
        {
          path: "company/:id",
          component: CompanyView,
          name: "companyView",
        },
        {
          path: "account",
          component: AccountView,
        },
      ],
    },
    { path: "*", component: PageNotFound },
  ],
});

import { getUser } from "./components/userauth/auth.js";

router.beforeResolve(async (to, from, next) => {
  //console.log('beforeResolve', to, from)
  const user = await getUser();
  //console.log('user', user)
  if (!user) {
    //console.log('wtf no user???', user)
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      return next({
        path: "/auth",
        params: to.params,
      });
    }
  } else {
    if (to.matched.some((record) => typeof record.meta.requiresAuth === "boolean" && !record.meta.requiresAuth)) {
      return next({
        path: "/home",
      });
    }
  }
  return next();
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map((el) => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

import vuetify from "./plugins/vuetify";

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
